import { useMutation } from 'react-query';
import * as sapi from '../services/sapi';

export default function useStagedTxnReIngestionMutation() {
  // see api docs in sapi for what request body options to send
  return useMutation('stagedTxReIngestion', reqBody =>
    sapi.post('/dri/staged-transactions/re-ingest', reqBody),
  );
}
